// ------------------------------------------------------------------------------------------------------
// VENDOR LIBRARIES

import $ from "jquery";
import "slick-carousel";
import "bootstrap";
import "magnific-popup";
import "jquery-touchswipe";
import "parsleyjs";
import "sharer.js";
import Splide from '@splidejs/splide';

import * as Sentry from "@sentry/browser";
import sentryConfig from './logging/sentry';

// ------------------------------------------------------------------------------------------------------
// SITE COMPONENTS

import './components/lazy-loader';

import Sliders from './components/sliders'
import AltHeader from './components/alt-header';
import ContactPopup from './components/popup';
import VideoPopups from './components/video-popups';
import FormValidation from './components/form-validation';
import SiteHeader from './components/site-header';
import Donate from './components/donate';
import NewsLoader from './components/news-loader';
import FormHelpers from './components/form-helpers';
import UVChart from './components/uv-chart';
import GalleryPopup from './components/gallery-popup';
import shopReLoader from './components/shop';
import DonationPopup from './components/donation-popup';
import ContactForm from './components/contact-form';
import BookAPresentationForm from './components/presentation-form';

import RecaptchaForm from './components/recaptcha-form';
import './components/counter-animated';

// ------------------------------------------------------------------------------------------------------
// APP ENTRY POINT

let App = function() {
    Sentry.init( sentryConfig );
};

App.prototype.init = function() {
    FormValidation.init();

    // Sliders
    Sliders.init();

    //Alternate Header/nav
    AltHeader.init();

    //Main site header/nav
    SiteHeader.init();

    // Popups initialisation
    ContactPopup.init(RecaptchaForm);

    // AJAX videos popups
    VideoPopups.init();

    Donate.init();

    // AJAX news article loader
    NewsLoader.init();

    // Donation/Checkout form helper functions
    FormHelpers.init();

    // UV Chart
    UVChart.init();

    // Shop on change of params re-loader
    shopReLoader.init();

    // Donation popup
    if ( document.body.classList.contains( 'bchc' ) ) {
        new DonationPopup( window.donationPopupConfig || {} );
    }

    // Album Gallery Popups
    const $albumPopups = $(document).find(".album-popup");

    if ($albumPopups.length > 0) {

        $albumPopups.each((i, el) => {

            $(el).magnificPopup({
                type: 'ajax',
                closeOnBgClick: true,
                callbacks: {
                    ajaxContentAdded: function() {
                        this.gallery = new GalleryPopup(this.content);
                    }
                }
            });

        })
    }

    var productSearchForm = document.querySelector( '#product-search-form' );
    if ( productSearchForm ) {
        var productSort = productSearchForm.querySelector( 'select[name=sort]' );
        productSort.addEventListener( 'change', function() {
            productSearchForm.submit();
        } );
    }

    var continueToCheckoutBtn = document.querySelector( '[data-action="continueToCheckout"]' );
    var checkoutForm = document.querySelector( '#checkout-form' );

    if ( continueToCheckoutBtn && checkoutForm ) {
        var $checkoutForm = $( '#checkout-form' );

        $( $checkoutForm ).parsley( {
            trigger: 'change', // Which event to trigger validation on
            errorClass: 'is-invalid', // Class when there are errors
            successClass: 'is-valid', // Class for successful validation
            //errorsMessagesDisabled: false, // Whether to add disable messages on each field
            whitespace: 'trim', // Trim whitespace before validation
            validationThreshold: 1, // Minimum number of chars before validation will fire
            errorTemplate: '<span></span>',
            priorityEnabled: true,
            classHandler: function(field) {
                var tagName = (field.$element.prop('tagName') || '').toLowerCase();
                var type = (field.$element.attr('type') || '').toLowerCase();
            }
        } );
        
        continueToCheckoutBtn.addEventListener( 'click', function( event ) {
            event.preventDefault();
            
            var isValid = $( '#checkout-form' ).parsley().validate();
            if ( !isValid ) {
                return;
            }

            window.location.href = continueToCheckoutBtn.dataset.href;
        } );
    }

    var quickLinks = document.querySelector( '.search-bar-quick-links' );
    var searchBarInputs = document.getElementsByClassName( 'search-bar-input' );

    if ( quickLinks && searchBarInputs.length > 0 ) {
        let closingTimeout;

        for ( let i = 0; i < searchBarInputs.length; i++ ) {
            searchBarInputs[ i ].addEventListener( 'focus', function( event ) {
                if ( closingTimeout ) {
                    clearTimeout( closingTimeout );
                }

                var inputForm = event.target.parentNode.parentNode;
                inputForm.classList.add( 'quickLinksOpen' );

            } );

            searchBarInputs[ i ].addEventListener( 'blur', function( event ) {
                closingTimeout = setTimeout( () => {
                    var inputForm = event.target.parentNode.parentNode;
                    inputForm.classList.remove( 'quickLinksOpen' );
                }, 100 );
            } );
        }
    }
    
    const splides = document.querySelectorAll( '.splide' );

    splides.forEach( el => {
        new Splide( el ).mount();
    } );

    const rflContactForm = document.querySelector( '[data-type="rfl-contact-form"]' )
    if ( rflContactForm ) {
        ContactForm.init( $( '[data-type="rfl-contact-form"]' ) );
    }

    document.querySelectorAll( '.book-a-presentation-form' ).forEach( form => new BookAPresentationForm( form ) );

    /**
     * Single line init actions here (Usually for jQuery plugins)
     */

    $('[data-toggle="tooltip"]').tooltip();

};

// ------------------------------------------------------------------------------------------------------
// GLOBALS
window.$ = window.jQuery = $;
window.app = new App();
window.app.init();